import { useCallback, useEffect, useState } from "react";

import { isLoggedIn, type ServiceError, SpinnerCenter } from "@shapr3d/frontend-lib";
import { useMutation } from "@tanstack/react-query";

import VoucherClaimResult, {
  VoucherClaimRequestResult,
} from "../components/VoucherClaimResult/VoucherClaimResult";
import useNavigation from "../hooks/navigation";
import useUrlHelper from "../hooks/urlHelper";
import { UMSrequestClient } from "../stores/requestClient";
import { SearchParam } from "../types";

const VoucherClaimContainer = () => {
  const urlHelper = useUrlHelper();
  const navigation = useNavigation();
  const voucherCode = urlHelper.getQueryParams().voucherId;
  const [isVerifying, setIsVerifying] = useState(true);
  const [claimResult, setClaimResult] = useState<VoucherClaimRequestResult>();

  const getRequestClaimOrVerify = useCallback(() => {
    if (!isLoggedIn()) {
      return UMSrequestClient.publicRequest({
        method: "GET",
        url: `/voucher/verify/${voucherCode}`,
      });
    } else {
      return UMSrequestClient.authenticatedRequest({
        method: "GET",
        url: `/voucher/claim/${voucherCode}`,
      });
    }
  }, [voucherCode]);

  const handleSubmitSuccess = useCallback(() => {
    setIsVerifying(false);
    setClaimResult(VoucherClaimRequestResult.Success);
    if (!isLoggedIn()) {
      navigation.goToSignUp({
        [SearchParam.RedirectUrl]: encodeURIComponent(window.location.href),
      });
    }
  }, [navigation]);

  const handleSubmitError = useCallback((error: ServiceError) => {
    setIsVerifying(false);
    setClaimResult(error.serviceErrorResponse.code as VoucherClaimRequestResult);
  }, []);

  const { isSuccess, isError, mutate } = useMutation({
    mutationFn: getRequestClaimOrVerify,
    onSuccess: handleSubmitSuccess,
    onError: handleSubmitError,
  });

  const showVoucherClaimResult = (isSuccess && isLoggedIn()) || isError;

  useEffect(() => {
    mutate();
  }, [mutate]);

  if (isVerifying) {
    return <SpinnerCenter />;
  }
  return (
    <>
      {showVoucherClaimResult && claimResult && (
        <VoucherClaimResult result={claimResult} isVerificationError={!isLoggedIn()} />
      )}
    </>
  );
};

export default VoucherClaimContainer;
